<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenters1"><a id="page_ii"></a>R<span class="small">ELIGION</span>, R<span class="small">ACE, AND</span> E<span class="small">THNICITY</span><br/>General Editor: Peter J. Paris</p>
<p class="textcenters1"><em>Public Religion and Urban Transformation: Faith in the City</em><br/>Edited by Lowell W. Livezey</p>
<p class="textcenters1"><em>Down by the Riverside: Readings in African American Religion</em><br/>Edited by Larry G. Murphy</p>
<p class="textcenters1"><em>New York Glory: Religions in the City</em><br/>Edited by Tony Carnes and Anna Karpathakis</p>
<p class="textcenters1"><em>Religion and the Creation of Race and Ethnicity: An Introduction</em><br/>Edited by Craig R. Prentiss</p>
<p class="textcenters1"><em>God in Chinatown: Religion and Survival in New York’s<br/>Evolving Immigrant Community</em><br/>Kenneth J. Guest</p>
<p class="textcenters1"><em>Creole Religions of the Caribbean: An Introduction from<br/>Vodou and Santería to Obeah and Espiritismo</em><br/>Margarite Fernández Olmos and Lizabeth Paravisini-Gebert</p>
<p class="textcenters1"><em>The History of the Riverside Church in the City of New York</em><br/>Peter J. Paris, John Wesley Cook, James Hadnut-Beumler, Lawrence H. Mamiya, Leonora Tubbs Tisdale, and Judith Weisenfeld<br/>Foreword by Martin E. Marty</p>
<p class="textcenters1"><em>Righteous Content: Black Women’s Perspectives of Church and Faith</em><br/>Daphne C. Wiggins</p>
<p class="textcenters1"><em>Beyond Christianity: African Americans in a New Thought Church</em><br/>Darnise C. Martin</p>
<p class="textcenters1"><em>Deeper Shades of Purple: Womanism in Religion and Society</em><br/>Edited by Stacey M. Floyd-Thomas</p>
<p class="textcenters1"><em>Daddy Grace: A Celebrity Preacher and His House of Prayer</em><br/>Marie W. Dallam</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?40382ef0